// extracted by mini-css-extract-plugin
export default {"container":"banner-planos_container__0Msik","lista-planos":"banner-planos_lista-planos__Kzk1x"};